export default __webpack_public_path__ + "static/media/story.558c55a6.png";